import React from 'react'

const Payment = () => {
    const cart = localStorage.getItem("cart-product")

    return (
        <div className='py-4 md:py-[100px] px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] flex justify-center'>
            <div className='w-full md:w-[80%] xl:w-[60%] '>
                <div className='bg-primary w-full p-3 md:p-4 flex justify-between'>
                    <p className='text-[18px] md:text-[20px] leading-6 font-semibold'>Order Overview</p>
                    <p></p>
                </div>
            </div>
        </div>
    )
}

export default Payment